import { render, staticRenderFns } from "./HeaderDropdownTasks.vue?vue&type=template&id=13fce590&"
import script from "./HeaderDropdownTasks.vue?vue&type=script&lang=js&"
export * from "./HeaderDropdownTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports